import { Global_Retorna_Permissoes } from "../../Funcoes_Globais";
//import * as RiIcons from "react-icons/ri";
//import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";
//import * as PiIcons from "react-icons/pi";
//import * as Fa6Icons from "react-icons/fa6";
//import * as TbIcons from "react-icons/tb";
import * as IoIcons from "react-icons/io";

var codigo_interno = 0

export const BarraLateralDados2 = () =>{
    //var lista_permissoes = JSON.parse(Global_Async_Local_Storage.getItem('dados_permissoes')) ? JSON.parse(Global_Async_Local_Storage.getItem('dados_permissoes')) : [];
    var json = [];
    var json_Submenu_Configuracoes = [];
    var json_Submenu_Cora = [];
    var json_Submenu_Financeiro = [];
    var json_Submenu_Plano_De_Contas = [];
    var objJson = {};

    codigo_interno = codigo_interno + 1
    objJson = {
        key: codigo_interno, 
        titulo: 'Dashboard',
        caminho: '/dashboard',
        //icone: <FaIcons.FaRegArrowAltCircleRight />,   
    };
    json.push(objJson);     

    if (Global_Retorna_Permissoes('cliente', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno,
            titulo: 'Clientes',
            caminho: '/revenda/clientes/consulta',
            //icone: <FaIcons.FaRegArrowAltCircleRight />,   
        };
        json.push(objJson);        
    }
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Planos',
            caminho: '/revenda/planos/consulta',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,   
        };
        json.push(objJson);
    }

    //Início SubMenu Financeiro
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Despesas',
            caminho: '/financeiro/despesa/consulta',
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Financeiro.push(objJson);        
    }
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Relatório DRE',
            caminho: '/financeiro/relatorios/dre',
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Financeiro.push(objJson);        
    }    
    if (json_Submenu_Financeiro.length > 0){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Financeiro',
            caminho: '#',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,
            iconeFechado: <FaIcons.FaArrowAltCircleDown/>,
            iconeAberto: <FaIcons.FaArrowAltCircleUp/>,
            subMenu: json_Submenu_Financeiro,               
        };
        json.push(objJson);         
    }
    //Fim SubMenu Financeiro       
    
    //Início SubMenu Cora
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Boletos',
            caminho: '/cora/boletos/consulta',
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Cora.push(objJson); 
        
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno,
            titulo: 'Configurações',
            caminho: '/cora/config',
            icone: <IoIcons.IoIosArrowForward/>,                
        };
        json_Submenu_Cora.push(objJson);          

    }
    if (json_Submenu_Cora.length > 0){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Cora',
            caminho: '#',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,
            iconeFechado: <FaIcons.FaArrowAltCircleDown/>,
            iconeAberto: <FaIcons.FaArrowAltCircleUp/>,
            subMenu: json_Submenu_Cora,               
        };
        json.push(objJson);         
    }
    //Fim SubMenu das Cora   

    if (Global_Retorna_Permissoes('usuario', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno,
            titulo: 'Usuários',
            caminho: '/revenda/usuarios/consulta',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,   
        };
        json.push(objJson);        
    } 
    
    if (Global_Retorna_Permissoes('revenda', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Revendas',
            caminho: '/revenda/consulta',
            //icone: <FaIcons.FaRegArrowAltCircleRight />,    
        };
        json.push(objJson);        
    } 
    
    //Início SubMenu Plano de Contas
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Plano de Contas Resultado',
            caminho: '/plano_de_contas/conta_resultado/consulta',
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Plano_De_Contas.push(objJson);        
    }
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Plano de Contas Grupo',
            caminho: "/plano_de_contas/conta_resultado_grupo/consulta",
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Plano_De_Contas.push(objJson);        
    } 
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Plano de Contas Financeiro',
            caminho: '/plano_de_contas/conta_financeiro/consulta',
            icone: <IoIcons.IoIosArrowForward/>,   
        };
        json_Submenu_Plano_De_Contas.push(objJson);        
    }              
    if (json_Submenu_Plano_De_Contas.length > 0){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Plano de Contas',
            caminho: '#',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,
            iconeFechado: <FaIcons.FaArrowAltCircleDown/>,
            iconeAberto: <FaIcons.FaArrowAltCircleUp/>,
            subMenu: json_Submenu_Plano_De_Contas,               
        };
        json.push(objJson);         
    }
    //Fim SubMenu Financeiro      


    //Início SubMenu das configuraões
    if (Global_Retorna_Permissoes('config_perm', 'ver')){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno,
            titulo: 'Permissões',
            caminho: '/configuracoes/permissoes/consulta',
            icone: <IoIcons.IoIosArrowForward/>,                
        };
        json_Submenu_Configuracoes.push(objJson);

        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno,
            titulo: 'Log Serviços',
            caminho: '/configuracoes/logservicos/consulta',
            icone: <IoIcons.IoIosArrowForward/>,                
        };
        json_Submenu_Configuracoes.push(objJson);        
    }    
    
    if (json_Submenu_Configuracoes.length > 0){
        codigo_interno = codigo_interno + 1
        objJson = {
            key: codigo_interno, 
            titulo: 'Configurações',
            caminho: '#',
            //icone: <FaIcons.FaRegArrowAltCircleRight/>,
            iconeFechado: <FaIcons.FaArrowAltCircleDown/>,
            iconeAberto: <FaIcons.FaArrowAltCircleUp/>,
            subMenu: json_Submenu_Configuracoes,               
        };
        json.push(objJson);         
    }
    //Fim SubMenu das configuraões
    return json;
};